import { deepExtract } from 'helpers/deep';
import { readSessionStorage, writeSessionStorage } from 'redux/saga/helpers/local-storage';

export const OFFER_MODAL_KEY_NAME = 'cpOfferModalSeen';

export const hasSeenOfferModal = () => readSessionStorage(OFFER_MODAL_KEY_NAME, false);
export const markOfferModalAsSeen = () => writeSessionStorage(OFFER_MODAL_KEY_NAME, true);

export const formatPrice = ({ intl, currency, price, withFractionDigits = false }) =>
  intl.formatNumber(Math.max(0, price), {
    style: 'currency',
    currency,
    ...(!withFractionDigits && {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }),
  });

export const generateOfferContextVariables = ({ offer, initialPrice, recurringPrice }) => ({
  location_name: deepExtract('location.name', offer),
  initial_plan: {
    class_estimate_min: deepExtract('initial_plan.min_class_estimate', offer),
    class_estimate_max: deepExtract('initial_plan.max_class_estimate', offer),
    credits: deepExtract('initial_plan.credits_per_cycle', offer),
    duration: deepExtract('initial_duration_formatted', offer),
    price: initialPrice,
    unformatted_price: offer.price,
  },
  recurring_plan: {
    class_estimate_min: deepExtract('recurring_plan.min_class_estimate', offer),
    class_estimate_max: deepExtract('recurring_plan.max_class_estimate', offer),
    credits: deepExtract('recurring_plan.credits_per_cycle', offer),
    duration: '1 month',
    price: recurringPrice,
  },
});
